import styled from "styled-components";

export const EventWrapper = styled.div<{
  scrollLock: boolean;
  isApp: number | null;
}>`
  position: relative;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 100%;
  max-width: 500px;
  z-index: 10;
  background: #b0c6dc;
  transition: all 0.5s ease-in-out;
  padding-top: ${(p) => (p.isApp ? `${p.isApp}px` : "0px")};

  > .header {
    top: 0;
    position: fixed;
    max-width: 500px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 48px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 0 20px;
    z-index: 11;
    gap: 8px;
    top: ${(p) => (p.isApp ? `${p.isApp}px` : "0px")};

    > .close {
      cursor: pointer;
      width: 24px;
      height: 24px;
    }

    > .title {
      color: ${(p) => p.theme.color.black400};

      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }
`;

export const ContentWrapper = styled.div`
  position: relative;
  overflow: auto;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: #b0c6dc;
  transition: all 0.5s ease-in-out;
  display: flex;
  flex-direction: column;
  padding: 45px 0;

  > .map {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    padding: 0 58px 10px 56px;
    > img {
      width: 100%;
    }

    .runner-open-button {
      position: absolute;
      bottom: 11px;
      right: 16px;
      width: 134px;
      height: 30px;
      padding: 9px 12px 9px 12px;
      border-radius: 15px;
      background: rgba(246, 222, 0, 1);

      font-size: 12px;
      font-weight: 600;
      line-height: 14.32px;
      text-align: left;
    }
  }

  > .open-button {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 0px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 32px);
    height: 48px;
    text-align: center;
    border-radius: 8px;
    padding: 0px 16px;
    font-weight: 600;
    background-color: #f6de00;
    > img {
      margin-right: 8px;
    }
  }
`;
export const OpenChatSelectWrapper = styled.div`
  position: relative;
  max-width: 500px;
  left: 50%;
  flex: 1;
  border-radius: 8px;
  transform: translateX(-50%);
  width: calc(100% - 32px);
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 16px;
`;

export const OpenChatTitleWrapper = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: var(--Black-400, #444444);
`;

export const SelectorWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2%;
  z-index: 11;
  > .location {
    width: 23.5%;
    height: 30px;
    margin-bottom: 6px;
    cursor: pointer;
    flex-shrink: 0;
    color: #d9d9d9;
    text-align: center;

    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    padding: 7px 0px;
    border-radius: 15px;
    border: 1px solid #d9d9d9;
    background: white;
  }
`;

export const SeoulWrapper = styled.div`
  position: absolute;
  left: 38%;
  top: 18%;
  width: 5%;
  height: 7%;
`;

export const InChonWrapper = styled.div`
  position: absolute;
  left: 33%;
  top: 18%;
  width: 9%;
  height: 9%;
`;

export const KyungKiDoWrapper = styled.div`
  position: absolute;
  left: 30%;
  top: 0px;
  width: 20%;
  height: 34%;
`;

export const KangWonDoWrapper = styled.div`
  position: absolute;
  right: 20%;
  top: 0px;
  width: 30%;
  height: 33%;
`;

export const JunRaDoWrapper = styled.div`
  position: absolute;
  left: 20%;
  bottom: 15%;
  width: 32%;
  height: 34%;
`;

export const BuSanWrapper = styled.div`
  position: absolute;
  right: 20%;
  bottom: 20%;
  width: 28%;
  height: 24%;
`;

export const DaeGuWrapper = styled.div`
  position: absolute;
  right: 18%;
  bottom: 44%;
  width: 30%;
  height: 23%;
`;

export const ChwoongChungDoWrapper = styled.div`
  position: absolute;
  left: 22%;
  bottom: 49%;
  width: 30%;
  height: 18%;
`;

export const DaeJoenWrapper = styled.div`
  position: absolute;
  left: 42%;
  top: 40%;
  width: 10%;
  height: 8%;
`;

export const JaeJooDoWrapper = styled.div`
  position: absolute;
  left: 20%;
  bottom: 5%;
  width: 17%;
  height: 10%;
`;
